import { Component, ChangeDetectorRef, Input, SimpleChanges, ViewChild } from "@angular/core";
import { AbstractCustomControl, MakeProvider } from "../abstract-custom-control";
import { ChartDataSets, ChartOptions, ChartType } from "chart.js";
import { Label, Color, BaseChartDirective } from "ng2-charts";
import { List } from "immutable";
import { UserService } from '../../base-services/user.service';

@Component({
    selector: 'yt-chart',
    templateUrl: './chart.component.html',
    providers: [MakeProvider(YtChart)]
})
export class YtChart extends AbstractCustomControl<any> {
    constructor(protected changeDetectorRef: ChangeDetectorRef,
        protected userService: UserService){
        super(changeDetectorRef);
    }

    @ViewChild(BaseChartDirective, { static: true }) chart: BaseChartDirective | undefined;

    datasets: ChartDataSets[] = [];
    labels: Label[] = [];
    options: ChartOptions = {
        responsive: true,
        maintainAspectRatio: false
    };
    type: ChartType;
    colors: Color[] = [];
    legend: boolean;

    series: string[];

    data: List<List<any>>//[];

    height: number = 300;
    heightIndex: number = 1;

    @Input() Width: number;
    @Input() set Height(value: number){
        this.height = value;
    }

    @Input() set Data(values: List<List<any>>//[]
        ) {
        //if(!values)
            //return;

        //this.datasets[0] = { data: [], label: ''};
        //let dataValues = [];
        //values.forEach(item => {
            //dataValues.push(item[this.ValueColumnName])
            //this.datasets[0].data.push(0);
        //})
        //this.datasets[0].data = dataValues;
        //if(values && values.length > 0)
            this.data = values;
    }

    @Input() ValueColumnName: string;
    @Input() LabelColumnName: string;

    @Input() set Type(value: ChartType) {
        this.type = value;
    }

    @Input() set Series(value: string){
        this.series = value.split(',');
    }

    ngOnChanges(changes: SimpleChanges){
        if(this.data && this.ValueColumnName && this.LabelColumnName //&& this.data.length > 0
            ){
            //this.datasets[0] = { data: [], label: '' };
            //let dataValues = [];
            //this.data.forEach(item => {
                //dataValues.push(item[this.ValueColumnName]);
                //this.labels.push(item[this.LabelColumnName]);
            //})
            //this.datasets[0].data = dataValues;

            this.datasets = [];
            this.data.forEach((serie, index) => {
                this.processSerie(serie, index);
            })

            //this.processLabels(this.data[0]);
            this.processLabels(this.data.get(0));

            //this.options = { ...this.options };
        }
    }

    processSerie(serie: List<any>, index: number) {
        this.datasets[index] = { data: [], label: this.series[index] };
        let tempValues = [];
        serie.forEach(item => {
            tempValues.push(item[this.ValueColumnName]);
        })
        this.datasets[index].data = tempValues;
    }

    processLabels(serie: List<any>) {
        //this.series = [];
        this.labels = [];
        serie.forEach(item => {
            this.labels.push(this.getLabelValue(item[this.LabelColumnName]));
        })
    }

    getLabelValue(value){
        if(value instanceof Object && value['day'] != null)
            //return value['day'] + '/' + value['month'] + '/' + value['year'];
            return value['day'] + this.userService.GetDateSeparator() + value['month'] + this.userService.GetDateSeparator() + value['year'];
        
        return value;
    }

    changeChartType(chartType: ChartType){
        this.type = chartType;
        //if(this.height == 300)
            //this.height = this.height + 1;
        //else if(this.height == 301)
            //this.height = this.height - 1;
        this.height = this.height + this.heightIndex;
        this.heightIndex = 0 - this.heightIndex;
        //this.ngOnChanges(null);
        //this.options = { ...this.options };
        //this.ngOnChanges(null);
        this.chart.update();
    }
}